export default function formatPercent(number) {
  return `${number * 100}%`;
}